// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__DSu_5","subheader":"ReorderModal_subheader__NapR3","listWrap":"ReorderModal_listWrap__3YHrJ"};